<div>
    <div class = "dialog-header-container">
        <h2 mat-dialog-title class="mar-b-5 pd-t-5px">Not Held Reason</h2>
        <div>            
            <button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
        </div>
    </div>
    <mat-divider class="mat-divider"></mat-divider>
    <div mat-dialog-content class="dialog-with-actions">
        <div class="row m-t-15">
            <mat-form-field class="body-font-size">
                <textarea class="body-font-size"  id="notHeldMeetingId" [(ngModel)]="reason"  matInput placeholder="Reason"  name="name" autocomplete="off" ></textarea>
            </mat-form-field>
        </div>
    </div>
    <div class="row d-flex justify-content-end" mat-dialog-actions>
        <button class="primary save-custom" type="button" mat-raised-button color="primary" (click)="notHeldMeeting()">SAVE</button>
        <button type="button" #editModalClose mat-raised-button color="primary" class="cancel-custom primary" (click)="closeDialog()">CANCEL</button>
    </div>
</div>